import React from "react";
import ReactApexChart from "react-apexcharts";
import useWindowDimensions from "../../utils/useWindowDimensions";
import { toTitleCase } from "../../utils/common";

const AreaWise = ({ data }) => {
  let { width } = useWindowDimensions();

  const chartData = {
    series: [
      {
        data: data?.map((item) => ({
          x: toTitleCase(item?.areaName),
          y: item?.violationCount,
        })),
      },
    ],
    options: {
      legend: {
        show: false,
      },
      chart: {
        type: "treemap",
        toolbar: {
          show: false,
        },
      },
      colors: ["#ca373c"],
      dataLabels: {
        enabled: true,
        style: {
          fontSize: "12px",
        },
      },
      plotOptions: {
        treemap: {
          enableShades: true,
          shadeIntensity: 0.5,
          reverseNegativeShade: true,
        },
      },
      tooltip: {
        enabled: true,
        followCursor: true,
        y: {
          show: true,
          formatter: (val, opts) => {
            const violationCount = opts?.w?.config?.series[0]?.data[opts?.dataPointIndex]?.y;
            return `Violation: ${violationCount}`;
          },
        },
      },
    },
  };

  return (
    <div id="chart">
      <ReactApexChart
        options={chartData.options}
        series={chartData.series}
        type="treemap"
        height={width > 1400 && width < 1700 ? 239 : width >= 1700 ? 320 : 210}
      />
    </div>
  );
};

export default AreaWise;
